/** The three inputs a tinted `w-badge`/`w-tag` takes: `[color]`, `[backgroundColor]`, `[borderColor]`. */
export interface BadgeTint {
    text: string;
    background: string;
    border: string;
}

/**
 * Manage Job Pro's badge tint recipe — status/entity-coloured text over light washes of the same
 * colour. Mixes at runtime rather than picking token shades (the invoice/bill tag approach) because
 * the colour here is whatever the status/entity was configured with. One definition so the header
 * chips, stage cards, stage details, resource pills and Related Links tags can never drift apart.
 */
export function badgeTint(color: string): BadgeTint {

    if (!color) return null;

    return {
        // Label and outline keep the status/entity hue and chroma but take fixed lightnesses, so a
        // pale colour (the yellow priority) can neither paint text onto its own wash nor wash its
        // outline out to white. A browser without relative colour syntax drops the declarations and
        // the badge's own --badge-text / neutral border apply, which stay legible.
        // Text lightness 0.55 ≈ the -700 ramp step the Figma Resources pills use — dark enough to
        // read on the 14% wash without the near-black weight the original 0.45 had.
        text: `oklch(from ${color} 0.55 c h)`,
        background: `color-mix(in srgb, ${color} 14%, #fff)`,
        border: `oklch(from ${color} 0.85 c h)`
    };
}
